import { Menu } from 'antd';
import styled from 'styled-components';

const { SubMenu: AntSubMenu } = Menu;

export const StyledSubMenu = styled(AntSubMenu)`
  /* Style the SubMenu title container - make it transparent so MenuItem styling shows through */
  .ant-menu-submenu-title {
    padding: 0 !important;
    margin: 0 !important;
    height: auto !important;
    line-height: normal;
    background-color: transparent !important;
    border: none !important;
    border-radius: 0;
    min-width: 180px !important;
    width: 100% !important;

    /* Ensure title content has full width */
    .ant-menu-title-content {
      width: 100% !important;
    }

    /* Remove default Ant Design SubMenu arrow - we use MenuItem's arrow instead */
    .ant-menu-submenu-arrow {
      display: none !important;
    }

    /* Remove any default hover/active states from SubMenu title - let MenuItem handle it */
    &:hover:not(.ant-menu-submenu-disabled) {
      background-color: transparent !important;
    }

    &.ant-menu-submenu-open {
      background-color: transparent !important;
    }

    &.ant-menu-submenu-disabled {
      background-color: transparent !important;
      cursor: not-allowed !important;
      opacity: 1 !important;
    }
  }
`;

